module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_library.js
// module id = 80
// module chunks = 0